
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container">
  <div class="row" *ngIf="loading">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="card-item">
            <md-spinner-block></md-spinner-block>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row step-description-block" *ngIf="!loading">
    <div class="col">
      <p>Enter additional information for this project:</p>
      <div class="row justify-content-md-center">
        <div class="col-md-10 p-0">
          <error [error]="error"></error>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="warningMessage">
        <div class="alert alert-warning col-md-10"><span></span><b>Warning: </b><span>{{warningMessage}}</span></div>
      </div>
    </div>
  </div>
  <form [formGroup]="deliveryInfoForm" (ngSubmit)="autoNextStep()">
    <fieldset [disabled]="isLocked || !workflowTargetInfo.correctRole">
      <div class="row justify-content-md-center mb-3">
        <div class="col-md-10 card-block">
          <div class="m-2">
            <div class="row mb-3">
              <div class="col-12">
                <h5 class="float-left">Contract Accounts</h5><span class="float-right">
                  <button class="btn btn-link text-danger font-weight-bold" type="button" (click)="rejectProject()"> {{ projectRejected ? 'Update Project Rejection' : 'Reject Project' }}</button></span>
              </div>
              <contract-account-panel #contractAccountsForm [projectId]="projectId" [defaultContractAccountId]="defaultContractAccountId" [deliveryInfoForm]="deliveryInfoForm" [addressDetails]="addresstoContractAccount" [itsmCustomerId]="itsmCustomerId" [resellerCustomerId]="resellerCustomerId" [opportunityID]="opportunityId" (contractAccountDetails)="contractAccountDetails($event)" [disableSelection]="disableCASelection" (mappedContractAccounts)="mappedContractAccounts($event)"></contract-account-panel>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center mb-3">
        <div class="col-md-10 card-block contract-details-card">
          <div class="m-2">
            <div class="row mb-2">
              <div class="col-lg-6">
                <div class="mt-2">
                  <h5 class="float-left">Contract Details</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="m-2">
            <div class="row">
              <div class="form-group col-md-6">
                <label class="required" for="csa">CSSA number:</label>
                <input class="form-control" id="csa" type="text" formControlName="csa" name="csa" maxlength="10" required>
              </div>
              <div class="form-group col-md-6">
                <label class="required" for="supplyRoutingId">Supplies Routing ID:</label>
                <input class="form-control" id="supplyRoutingId" type="text" formControlName="supplyRoutingId" name="supplyRoutingId" maxlength="30" required>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="customerErpNumber">HP Customer Number (SANDY):</label>
                <input class="form-control" id="customerErpNumber" type="text" formControlName="customerErpNumber" name="customerErpNumber" maxlength="40">
              </div>
              <div class="form-group col-md-6"></div>
              <div class="form-group col-md-6">
                <label for="opgNumber">Big Deal ID:</label><span class="btn btn-primary btn-circle-sm oi oi-question-mark ml-2" *ngIf="por721" data-toggle="tooltip" data-placement="top" title="If a 'Bundle ID' or 'Config ID' is specified for any device, providing a 'Big Deal ID' becomes necessary."></span>
                <input class="form-control" id="opgNumber" type="text" formControlName="opgNumber" name="opgNumber" [attr.maxlength]="por721 ? 10 : 50">
              </div>
              <div class="form-group col-md-6">
                <label for="saLetter">SAL ID:</label>
                <input class="form-control" id="saLetter" type="text" formControlName="saLetter" name="saLetter" maxlength="30">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label class="required">Source Documentation Link:</label>
                <p *ngIf="sourceDocumentationLink"><a class="break-word" [href]="sourceDocumentationLink" target="_blank">{{ sourceDocumentationLink }}</a></p>
              </div>
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-md-7 col-lg-8 pr-lg-0">
                    <label class="required" id="orderAcceptenceLabel">Order Acceptance</label>
                  </div>
                  <div class="col-md-5 col-lg-4 col-xs-12 d-inline-flex pl-md-0">
                    <div class="form-check flex-grow-1 flex-md-grow-0">
                      <div class="d-block float-md-right">
                        <input class="form-check-input" id="orderAcceptanceYes" type="radio" name="orderAcceptance" formControlName="orderAcceptance" autoLinkToLabel [value]="true">
                        <label class="form-check-label">Yes</label>
                      </div>
                    </div>
                    <div class="form-check flex-grow-1">
                      <div class="d-block float-md-right">
                        <input class="form-check-input" id="orderAcceptanceNo" type="radio" name="orderAcceptance" formControlName="orderAcceptance" autoLinkToLabel [value]="false">
                        <label class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="projectAllowsFedLLC">
              <div class="form-group col-md-6">
                <div class="div">
                  <label class="required">Sales Organization</label>
                  <div class="form-check float-right">
                    <input class="form-check-input" id="salesOrganizationUS13" type="radio" name="salesOrganization" formControlName="salesOrganization" autoLinkToLabel value="US13">
                    <label class="form-check-label">US13 Fed LLC</label>
                  </div>
                  <div class="form-check float-right pr-4">
                    <input class="form-check-input" id="salesOrganizationUS11" type="radio" name="salesOrganization" formControlName="salesOrganization" autoLinkToLabel value="US11">
                    <label class="form-check-label">US11</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-md-7 col-lg-8 pr-lg-0">
                    <label>Coterminous</label>
                  </div>
                  <div class="col-lg-4 col-md-5 col-xs-12 d-inline-flex pl-md-0">
                    <div class="form-check flex-grow-1 flex-md-grow-0">
                      <div class="d-block float-md-right">
                        <input class="form-check-input" id="coTerminousYes" type="radio" name="coTerminous" formControlName="coTerminous" autoLinkToLabel [value]="true" [attr.disabled]="true">
                        <label class="form-check-label">Yes</label>
                      </div>
                    </div>
                    <div class="form-check flex-grow-1">
                      <div class="d-block float-md-right">
                        <input class="form-check-input" id="coTerminousNo" type="radio" name="coTerminous" formControlName="coTerminous" autoLinkToLabel [value]="false" [attr.disabled]="true">
                        <label class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row">
                  <label class="required col-lg-7 m-0 col-md-6">Order Acceptance Completion Date</label>
                  <datepicker class="right input-group-append col-lg-5 col-md-6" id="orderAcceptanceCompleteDatePicker" formControlName="orderAcceptanceCompleteDate" [value]="deliveryInfoForm.controls.orderAcceptanceCompleteDate?.value" showInputOnly="orderAcceptanceCompleteDate"></datepicker>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6" *ngIf="coTerminous">
                <div class="row">
                  <label class="col-lg-7">Coterminous End Date</label>
                  <datepicker class="right input-group-append col-lg-5" id="coTerminousDatePicker" formControlName="coTerminousDatePicker" (outputEvents)="DPToTxt('coTerminousDate')" showInputOnly="coTerminousDate"></datepicker>
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="row">
                  <div class="col-md-7 col-lg-8 pr-lg-0">
                    <label class="required" id="allowExeedQuantitiesLabel">Allow site design and ordering to exceed quantities specified in the DART deal</label>
                  </div>
                  <div class="col-lg-4 col-md-5 col-xs-12 d-inline-flex pl-md-0 align-self-md-baseline">
                    <div class="form-check flex-grow-1 flex-md-grow-0">
                      <div class="d-block float-md-right">
                        <input class="form-check-input" id="enableCatalogPricingYes" type="radio" name="enableCatalogPricing" formControlName="enableCatalogPricing" autoLinkToLabel [value]="true">
                        <label class="form-check-label">Yes</label>
                      </div>
                    </div>
                    <div class="form-check flex-grow-1">
                      <div class="d-block float-md-right">
                        <input class="form-check-input" id="enableCatalogPricingNo" type="radio" name="enableCatalogPricing" formControlName="enableCatalogPricing" autoLinkToLabel [value]="false">
                        <label class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6"></div>
              <div class="form-group col-md-6 col-xs-6">
                <div class="row">
                  <div class="col-lg-7 col-md-6">
                    <label for="vendorContractAccNumber">Vendor Contract Account Number</label>
                  </div>
                  <div class="col-lg-5 col-md-6">
                    <input class="form-control" id="vendorContractAccNumber" type="text" formControlName="vendorContractAccNumber" name="vendorContractAccNumber">
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6 col-xs-6">
                <div class="row">
                  <label class="required col-lg-7 col-md-6">Master Agreement Start Date</label>
                  <datepicker class="right input-group-append col-lg-5 col-md-6" id="maStartDatePicker" formControlName="maStartDatePicker" [isDisabled]="_isMAActive" (outputEvents)="DPToTxt('maStartDate')" showInputOnly="maStartDate"></datepicker>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6 col-md-6">
                <label class="required">Commerciality Code</label>
                <select class="form-control" id="commercialityCode" name="commercialityCode" formControlName="commercialityCode" autoLinkToLabel>
                  <option></option>
                  <option *ngFor="let code of commercialityCodeValues" [ngValue]="code.id">{{ code.value }}</option>
                </select>
              </div>
              <div class="form-group col-lg-6 col-md-6">
                <div>
                  <label class="required">Global Deal</label>
                  <select class="form-control" id="globalDeal" name="globalDeal" formControlName="globalDeal" autoLinkToLabel (change)="checkGlobalDealValue($event.target.value)">
                    <option></option>
                    <option *ngFor="let gdVal of globalDealValues" [ngValue]="gdVal.id">{{ gdVal.value }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label class="required" *ngIf="gdClassificationRequired">Global Deal Classification</label>
                <label *ngIf="!gdClassificationRequired">Global Deal Classification</label>
                <select class="form-control" id="globalDealClassification" name="globalDealClassification" formControlName="globalDealClassification" autoLinkToLabel (change)="checkGlobalDealClassification($event.target.value)">
                  <option></option>
                  <option *ngFor="let gdcVal of globalDealClassificationValues" [ngValue]="gdcVal.id">{{ gdcVal.value }}</option>
                </select>
              </div>
              <div class="form-group col-lg-6 col-md-6">
                <div class="row">
                  <div class="col-md-6 col-lg-5">
                    <label class="required">In Advance / In Arrears</label>
                  </div>
                  <div class="col-md-6 col-lg-7 d-lg-inline-flex text-lg-right">
                    <div class="form-check flex-grow-1">
                      <input class="form-check-input" id="inadvanceInarrearsYes" type="radio" name="inadvanceInarrears" formControlName="inadvanceInarrears" autoLinkToLabel value="ARR" [attr.disabled]="true">
                      <label class="form-check-label">In Arrears</label>
                    </div>
                    <div class="form-check flex-grow-1">
                      <input class="form-check-input" id="inadvanceInarrearsNo" type="radio" name="inadvanceInarrears" formControlName="inadvanceInarrears" autoLinkToLabel value="ADV" [attr.disabled]="true">
                      <label class="form-check-label">In Advance</label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 15px;">
                  <div class="col-md-9 col-lg-7">
                    <label>Proof of Delivery Required</label>
                  </div>
                  <div class="col-lg-4 col-md-5 col-xs-12 d-inline-flex pl-md-0">
                    <div class="form-check flex-grow-1 flex-md-grow-0">
                      <div class="d-block float-md-right">
                        <input class="form-check-input" id="podRequiredYes" type="radio" name="podRequired" formControlName="podRequired" autoLinkToLabel [value]="true">
                        <label class="form-check-label">Yes</label>
                      </div>
                    </div>
                    <div class="form-check flex-grow-1">
                      <div class="d-block float-md-right">
                        <input class="form-check-input" id="podRequiredNo" type="radio" name="podRequired" formControlName="podRequired" autoLinkToLabel [value]="false">
                        <label class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6" *ngIf="centralToCentralSelected">
                <label class="required" *ngIf="gdClassificationRequired">Select Deployment Country</label>
                <label *ngIf="!gdClassificationRequired">Select Deployment Country</label>
                <select class="form-control" id="deployementCountry" name="deployementCountry" formControlName="deployementCountry" autoLinkToLabel (change)="ChangeDeployedCountry($event.target.value)">
                  <option *ngFor="let country of countries" [ngValue]="country.countryId">{{ country.countryName }}  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6 col-md-6" hidden>
                <div class="row">
                  <div class="col-md-7 col-lg-8 pr-lg-0">
                    <label class="required" id="allowFutureDatesLabel">Allow Future Install Dates</label>
                  </div>
                  <div class="col-lg-4 col-md-5 col-xs-12 d-inline-flex pl-md-0">
                    <div class="form-check flex-grow-1 flex-md-grow-0">
                      <div class="d-block float-md-right">
                        <input class="form-check-input" id="allowFutureInstallDatesYes" type="radio" name="allowFutureInstallDates" formControlName="allowFutureInstallDates" autoLinkToLabel [value]="true" [attr.disabled]="notCA">
                        <label class="form-check-label">Yes</label>
                      </div>
                    </div>
                    <div class="form-check flex-grow-1">
                      <div class="d-block float-md-right">
                        <input class="form-check-input" id="allowFutureInstallDatesNo" type="radio" name="allowFutureInstallDates" formControlName="allowFutureInstallDates" autoLinkToLabel [value]="false" [attr.disabled]="notCA">
                        <label class="form-check-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="por922TMC === true">
              <div class="form-group col-sm-4">
                <label class="required" for="multiYearTermDuration">Multi Year Term Duration<i> (# months)</i></label>
                <input class="form-control" id="multiYearTermDuration" type="number" formControlName="multiYearTermDuration" name="multiYearTermDuration" (keydown)="keydowned($event)" disabled>
              </div>
              <div class="form-group col-sm-4">
                <label class="required" [for]="'multiYearPoType'">Multi Year PO Type</label>
                <select class="form-control" id="multiyearPoType" name="multiYearPoType" formControlName="multiYearPoType" autoLinkToLabel>
                  <option *ngFor="let mypo of dorMultiPoTypeOptions" [ngValue]="mypo.id">{{ mypo.value }}</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <div>
                  <label class="required" [for]="'prepaidFieldOnDorTab'">Prepaid Field on DOR Tab</label>
                </div>
                <div>
                  <div class="form-check float-left pr-2">
                    <input class="form-check-input" id="prepaidFieldOnDorTabYes" type="radio" name="prepaidFieldOnDorTab" formControlName="prepaidFieldOnDorTab" autoLinkToLabel value="Y">
                    <label class="form-check-label">Yes</label>
                  </div>
                  <div class="form-check float-left pr-2">
                    <input class="form-check-input" id="prepaidFieldOnDorTabNo" type="radio" name="prepaidFieldOnDorTab" formControlName="prepaidFieldOnDorTab" autoLinkToLabel value="N">
                    <label class="form-check-label">No</label>
                  </div>
                  <div class="form-check float-left pr-2" *ngIf="por229_1tmc">
                    <input class="form-check-input" id="prepaidFieldOnDorTabCash" type="radio" name="prepaidFieldOnDorTab" formControlName="prepaidFieldOnDorTab" autoLinkToLabel value="P">
                    <label class="form-check-label">Cash in Advance</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center mb-3">
        <div class="col-md-10 card-block">
          <div class="m-2">
            <div class="row mb-2">
              <div class="col-lg-6" style="cursor: pointer;" (click)="toggleBillingCycleVisible=!toggleBillingCycleVisible">
                <div class="mt-2">
                  <h5 class="float-left">Billing Cycle</h5>
                </div>
              </div>
              <div class="col-lg-6 text-right"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Hide Billing Cycle" *ngIf="toggleBillingCycleVisible" (click)="toggleBillingCycleVisible = false"><span class="icon oi oi-chevron-top"></span></a><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show Billing Cycle" *ngIf="!toggleBillingCycleVisible" (click)="toggleBillingCycleVisible = true"><span class="icon oi oi-chevron-bottom"></span></a></div>
            </div>
            <ng-container *ngIf="toggleBillingCycleVisible">
              <div [formGroup]="billingCycleForm">
                <div class="row" *ngIf="devices &amp;&amp; devices.length &gt; (assets.monthly.length) &amp;&amp; (!assets.ftu.length &amp;&amp; !assets.ftuBftiad.length)">
                  <div class="form-group col-sm-4">
                    <label class="required" for="billingFrequencyDefault">Select Billing Frequency</label>
                    <select class="form-control" id="billingFrequencyDefault" name="billingFrequencyDefault" formControlName="billingFrequencyDefault" autoLinkToLabel (change)="filterBillingCycleValues()">
                      <option *ngFor="let bfVal of filteredBillingFrequencyValuesDefault" [ngValue]="bfVal.id">{{ bfVal.value }}</option>
                    </select>
                  </div>
                </div>
                <div class="card-block" *ngIf="message">{{message}}</div>
                <div class="card-block" *ngIf="!message &amp;&amp; filteredBillingCycleValues.length &amp;&amp; displayBCOthers.length">
                  <div class="row">
                    <div class="form-group col" *ngIf="filteredBillingCycleValues.length &amp;&amp; displayBCOthers.length">Model & Solution - Select solutions & map billing cycle
                      <div class="form-group col-sm-6 mt-1" *ngIf="filteredBillingCycleValues.length  &amp;&amp; assets.others.length" style="margin-bottom: 2rem;">
                        <label class="required" for="billingCycleDefault">Billing Cycle</label>
                        <select class="form-control" id="billingCycleDefault" name="billingCycleDefault" formControlName="billingCycleDefault" autoLinkToLabel (click)="assignBillingCycleValue($event.target.value)">
                          <option></option>
                          <option *ngFor="let bcVal of filteredBillingCycleValues" [ngValue]="bcVal.id">{{ bcVal.value }}</option>
                        </select>
                        <div class="row ml-2" *ngIf="displayMessage" style="position: absolute;"><span>Please select atleast one solution to update billing cycle</span></div>
                      </div>
                      <div class="row">
                        <div class="row" style="height: min-content; line-height: 1;">
                          <div class="ml-3">
                            <input class="form-check-input ml-3" name="checkUncheck" type="checkbox" formControlName="checkUncheck" (click)="checkUncheckAll($event.target.checked)" autoLinkToLabel>
                            <label class="form-check-label ml-5">Select/Unselect All</label>
                          </div>
                          <div class="row ml-5">
                            <p>Selected {{count}} / {{billingCycleOtherTotalCount}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="row container-fluid d-flex align-items-center justify-content-center">
                        <ng-template class="container-fluid" ngFor let-asset [ngForOf]="displayBCOthers">
                          <div class="col-md-5 card-block float-left ml-5" style="height: 9.75em;" [ngClass]="asset.style">
                            <div [ngClass]="assets.others.length &gt;1 ? 'card-block-multi-asset' : 'card-block-asset'">
                              <input class="form-check-input ml-1" type="checkbox" name="{{asset.id}}" id="{{asset.id}}" [formControlName]="asset.id" (change)="checkUncheckAll($event.target.checked, true)">
                              <label class="form-check-label ml-4" for="{{asset.id}}">
                                <p style="margin-bottom: 0.1rem;"><b>Description</b><span>: {{asset.productDescription}}</span></p>
                                <p style="margin-bottom: 0.1rem;"><b>Product no</b><span>: {{asset.productNumber}}</span></p>
                                <p style="margin-bottom: 0.1rem;"><b>DART Solution ID</b><span>: {{asset.deviceKey}}</span></p>
                                <p style="margin-bottom: 0.1rem;"><b class="required">Billing Cycle</b><span>: {{asset.billingCycle}}</span></p>
                              </label>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="!message">
                    <div class="col">
                      <list-controls [pageName]="&quot;BillingCycleOthers&quot;" [showSearch]="false" [limit]="billingCycleOtherPageSize" [page]="billingCycleOtherCurrentPage" [numPages]="billingCycleOtherMaxPages" [totalCount]="billingCycleOtherTotalCount" (onChange)="onListControlsChangeBCOthers($event)"></list-controls>
                    </div>
                  </div>
                </div><br><br>
                <div class="row mb-2" *ngIf="assets.monthly.length">
                  <p class="form-group col-md-12">Solutions having Billing Frequency as Monthly have been mapped to Billing Cycle -<b>M01 - Bill Cycle Monthly</b><span>by default</span></p>
                  <div class="col-lg-12" *ngIf="assets.monthly.length">
                    <div class="row form-group d-flex justify-content-center" style="height: 8rem; overflow-y: auto;">
                      <ng-template ngFor let-asset [ngForOf]="displayBCMonthly">
                        <div class="col-md-6" [ngClass]="assets.monthly.length &gt;1 ? 'card-block-multi-asset' : 'card-block-asset'">
                          <div class="card-block ml-3">
                            <p style="margin-bottom: 0.1rem;"><b>Description</b><span>: {{asset.productDescription}}</span></p>
                            <p style="margin-bottom: 0.1rem;"><b>Product no</b><span>: {{asset.productNumber}}</span></p>
                            <p style="margin-bottom: 0.1rem;"><b>DART Solution ID</b><span>: {{asset.deviceKey}}</span></p>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                    <div class="form-group col-lg-12">
                      <list-controls [pageName]="&quot;BillingCycleMonthly&quot;" [showSearch]="false" [limit]="billingCycleMonthlyPageSize" [page]="billingCycleMonthlyCurrentPage" [numPages]="billingCycleMonthlyMaxPages" [totalCount]="billingCycleMonthlyTotalCount" (onChange)="onListControlsChangeBCMonthly($event)"></list-controls>
                    </div>
                  </div>
                </div>
                <div class="row mb-2" *ngIf="por229_1tmc  &amp;&amp; assets.ftu.length">
                  <p class="form-group col-md-12" *ngIf="isFtuWithBFTIAD">Solutions having Billing frequency as Full Term upfront and Charge plan combo as BFTIAD have been mapped to Billing Cycle as <b>FTU- Full Term upfront </b><span>by default</span></p>
                  <div class="col-lg-12" *ngIf="assets.ftu.length">
                    <div class="row form-group d-flex justify-content-center" style="height: 8rem; overflow-y: auto;">
                      <ng-template ngFor let-asset [ngForOf]="displayBCFTU">
                        <div class="col-md-6" [ngClass]="assets.ftu.length &gt;1 ? 'card-block-multi-asset' : 'card-block-asset'">
                          <div class="card-block ml-3">
                            <p style="margin-bottom: 0.1rem;"> <b>Description</b><span>: {{asset.productDescription}}</span></p>
                            <p style="margin-bottom: 0.1rem;"> <b>Product no</b><span>: {{asset.productNumber}}</span></p>
                            <p style="margin-bottom: 0.1rem;"> <b>DART Solution ID</b><span>: {{asset.deviceKey}}</span></p>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                    <div class="form-group col-lg-12"> 
                      <list-controls [pageName]="&quot;BillingCycleFTU&quot;" [showSearch]="false" [limit]="billingCycleFTUPageSize" [page]="billingCycleFTUCurrentPage" [numPages]="billingCycleFTUMaxPages" [totalCount]="billingCycleFTUTotalCount" (onChange)="onListControlsChangeBCFTU($event)"></list-controls>
                    </div>
                  </div>
                </div>
                <div class="row mb-2" *ngIf="por229_1tmc  &amp;&amp; assets.ftuBftiad.length">
                  <p class="form-group col-md-12" *ngIf="isFtuWithoutBFTIAD">Solutions having Billing frequency as Full Term upfront and Charge plan combo is not BFTIAD have been mapped to Billing Cycle as <b>M01- Bill cycle Monthly </b><span>by default</span></p>
                  <div class="col-lg-12" *ngIf="assets.ftuBftiad.length">
                    <div class="row form-group d-flex justify-content-center" style="height: 8rem; overflow-y: auto;">
                      <ng-template ngFor let-asset [ngForOf]="displayBCFTU2">
                        <div class="col-md-6" [ngClass]="assets.ftuBftiad.length &gt;1 ? 'card-block-multi-asset' : 'card-block-asset'">
                          <div class="card-block ml-3">
                            <p style="margin-bottom: 0.1rem;"> <b>Description</b><span>: {{asset.productDescription}}</span></p>
                            <p style="margin-bottom: 0.1rem;"> <b>Product no</b><span>: {{asset.productNumber}}</span></p>
                            <p style="margin-bottom: 0.1rem;"> <b>DART Solution ID</b><span>: {{asset.deviceKey}}</span></p>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                    <div class="form-group col-lg-12"> 
                      <list-controls [pageName]="&quot;BillingCycleFTUWithoutBftiad&quot;" [showSearch]="false" [limit]="billingCycleFTUPageSize2" [page]="billingCycleFTUCurrentPage2" [numPages]="billingCycleFTUMaxPages2" [totalCount]="billingCycleFTUTotalCount2" (onChange)="onListControlsChangeBCFTUWithoutBftiad($event)"></list-controls>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center mb-3">
        <div class="col-md-10 card-block">
          <div class="m-2">
            <div class="row mb-2">
              <div class="col-lg-6">
                <div class="mt-2">
                  <h5 class="float-left">Invoice Splits</h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">
                <label class="required">Billing Model Split</label>
              </div>
              <div class="form-group col-md-3 text-right">
                <div class="form-check d-inline-block pr-4">
                  <input class="form-check-input" id="billingModelSplitYes" type="radio" name="billingModelSplit" formControlName="billingModelSplit" autoLinkToLabel [value]="true">
                  <label class="form-check-label">Yes</label>
                </div>
                <div class="form-check d-inline-block">
                  <input class="form-check-input" id="billingModelSplitNo" type="radio" name="billingModelSplit" formControlName="billingModelSplit" autoLinkToLabel [value]="false">
                  <label class="form-check-label">No</label>
                </div>
              </div>
              <div class="form-group col-md-3">
                <label class="required">Business Model Split</label>
              </div>
              <div class="form-group col-md-3 text-right">
                <div class="form-check d-inline-block pr-4">
                  <input class="form-check-input" id="businessModelSplitYes" type="radio" name="businessModelSplit" formControlName="businessModelSplit" autoLinkToLabel [value]="true">
                  <label class="form-check-label">Yes</label>
                </div>
                <div class="form-check d-inline-block">
                  <input class="form-check-input" id="businessModelSplitNo" type="radio" name="businessModelSplit" formControlName="businessModelSplit" autoLinkToLabel [value]="false">
                  <label class="form-check-label">No</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">
                <label class="required">Charge Type Split</label>
              </div>
              <div class="form-group col-md-3 text-right">
                <div class="form-check d-inline-block pr-4">
                  <input class="form-check-input" id="chargeTypeSplitYes" type="radio" name="chargeTypeSplit" formControlName="chargeTypeSplit" autoLinkToLabel [value]="true">
                  <label class="form-check-label">Yes</label>
                </div>
                <div class="form-check d-inline-block">
                  <input class="form-check-input" id="chargeTypeSplitNo" type="radio" name="chargeTypeSplit" formControlName="chargeTypeSplit" autoLinkToLabel [value]="false">
                  <label class="form-check-label">No</label>
                </div>
              </div>
              <div class="form-group col-md-3">
                <label class="required">End User Split</label>
              </div>
              <div class="form-group col-md-3 text-right">
                <div class="form-check d-inline-block pr-4">
                  <input class="form-check-input" id="endUserSplitYes" type="radio" name="endUserSplit" formControlName="endUserSplit" autoLinkToLabel [value]="true">
                  <label class="form-check-label">Yes</label>
                </div>
                <div class="form-check d-inline-block">
                  <input class="form-check-input" id="endUserSplitNo" type="radio" name="endUserSplit" formControlName="endUserSplit" autoLinkToLabel [value]="false">
                  <label class="form-check-label">No</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">
                <label class="required">Ship to BP Split</label>
              </div>
              <div class="form-group col-md-3 text-right">
                <div class="form-check d-inline-block pr-4">
                  <input class="form-check-input" id="shipToSplitYes" type="radio" name="shipToSplit" formControlName="shipToSplit" autoLinkToLabel value="Y">
                  <label class="form-check-label">Yes</label>
                </div>
                <div class="form-check d-inline-block">
                  <input class="form-check-input" id="shipToSplitNo" type="radio" name="shipToSplit" formControlName="shipToSplit" autoLinkToLabel value="N">
                  <label class="form-check-label">No</label>
                </div>
              </div>
              <div class="form-group col-md-3">
                <label class="required">Title Status Split</label>
              </div>
              <div class="form-group col-md-3 text-right">
                <div class="form-check d-inline-block pr-4">
                  <input class="form-check-input" id="tittleStatusSplitYes" type="radio" name="titleStatusSplit" formControlName="titleStatusSplit" autoLinkToLabel [value]="true">
                  <label class="form-check-label">Yes</label>
                </div>
                <div class="form-check d-inline-block">
                  <input class="form-check-input" id="tittleStatusSplitNo" type="radio" name="titleStatusSplit" formControlName="titleStatusSplit" autoLinkToLabel [value]="false">
                  <label class="form-check-label">No</label>
                </div>
              </div>
            </div>
            <div class="row" *appSetting="'enablePurchaseOrders'">
              <div class="form-group col-md-3">
                <label class="mt-2">Purchase Order Split</label><span class="btn btn-primary btn-circle-sm oi oi-question-mark ml-2" data-toggle="tooltip" data-placement="bottom" [title]="purchaseOrderSPlitHint"></span>
              </div>
              <div class="form-group col-md-3">
                <select class="form-control" id="purchaseOrderSplit" formControlName="purchaseOrderSplit" name="purchaseOrderSplit" autoLinkToLabel>
                  <option value="NONE" selected>No</option>
                  <option value="SOLUTION">Solutions</option>
                  <option value="OFFER">Offers</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center mb-3" *appSetting="'enablePurchaseOrders'">
        <div class="col-md-10 p-0">
          <purchase-order-card #purchaseOrderCardComponent [projectId]="projectId" [targetSystem]="targetSystem" (purchaseOrdersExistEvent)="purchaseOrdersExist($event)" [purchaseOrdersType]="deliveryInfoForm.controls['purchaseOrderSplit'].value" [isMAActive]="isMAActive" [isMpc]="isMpc"></purchase-order-card>
        </div>
      </div>
      <div class="row justify-content-md-center mb-3" *ngIf="por922TMC === false">
        <div class="col-md-10 card-block">
          <div class="m-2">
            <div class="row mb-2">
              <div class="col-lg-6">
                <div class="mt-2">
                  <h5 class="float-left">DOR Data</h5>
                </div>
              </div>
              <div class="col-lg-6 text-right"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Hide DOR Data" *ngIf="toggleDorDataVisible" (click)="toggleDorDataVisible = false"><span class="icon oi oi-chevron-top"></span></a><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show DOR Data" *ngIf="!toggleDorDataVisible" (click)="toggleDorDataVisible = true"><span class="icon oi oi-chevron-bottom"></span></a></div>
            </div>
            <ng-container *ngIf="toggleDorDataVisible">
              <div class="row">
                <div class="form-group col-sm-4">
                  <label class="required" for="multiYearTermDuration">Multi Year Term Duration<i> (# months)</i></label>
                  <input class="form-control" id="multiYearTermDuration" type="number" formControlName="multiYearTermDuration" name="multiYearTermDuration" (keydown)="keydowned($event)" disabled>
                </div>
                <div class="form-group col-sm-4">
                  <label class="required" [for]="'multiYearPoType'">Multi Year PO Type</label>
                  <select class="form-control" id="multiyearPoType" name="multiYearPoType" formControlName="multiYearPoType" autoLinkToLabel>
                    <option *ngFor="let mypo of dorMultiPoTypeOptions" [ngValue]="mypo.id">{{ mypo.value }}</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <div>
                    <label class="required" [for]="'prepaidFieldOnDorTab'">Prepaid Field on DOR Tab</label>
                  </div>
                  <div>
                    <div class="form-check float-left pr-2">
                      <input class="form-check-input" id="prepaidFieldOnDorTabYes" type="radio" name="prepaidFieldOnDorTab" formControlName="prepaidFieldOnDorTab" autoLinkToLabel value="Y">
                      <label class="form-check-label">Yes</label>
                    </div>
                    <div class="form-check float-left pr-2">
                      <input class="form-check-input" id="prepaidFieldOnDorTabNo" type="radio" name="prepaidFieldOnDorTab" formControlName="prepaidFieldOnDorTab" autoLinkToLabel value="N">
                      <label class="form-check-label">No</label>
                    </div>
                    <div class="form-check float-left pr-2" *ngIf="por229_1tmc">
                      <input class="form-check-input" id="prepaidFieldOnDorTabCash" type="radio" name="prepaidFieldOnDorTab" formControlName="prepaidFieldOnDorTab" autoLinkToLabel value="P">
                      <label class="form-check-label">Cash in Advance</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="por922TMC === false">
                <div class="form-group col-md-4">
                  <label class="required">Legacy Reported Date</label>
                  <datepicker class="right input-group-append" id="legacyReportedDatePicker" formControlName="legacyReportedDatePicker" (outputEvents)="DPToTxt('legacyReportedDate')" showInputOnly="legacyReportedDate" [isDisabled]="_isMAActive" [enableEditInput]="true"></datepicker>
                </div>
                <div class="form-group col-sm-4">
                  <label class="required" for="legacyDocumentType">Legacy Document Type</label>
                  <select class="form-control" id="legacyDocumentType" name="legacyDocumentType" formControlName="legacyDocumentType" autoLinkToLabel>
                    <option value="None">None</option>
                    <option value="ZCRN">ZCRN</option>
                    <option value="ZDCB">ZDCB</option>
                  </select>
                </div>
                <div class="form-group col-sm-4">
                  <label class="required" for="legacyDocumentNumber">Legacy Document Number</label>
                  <input class="form-control" id="legacyDocumentNumber" type="text" formControlName="legacyDocumentNumber" name="legacyDocumentNumber" maxlength="10">
                </div>
              </div>
              <div class="row" *ngIf="por922TMC === false">
                <div class="form-group col-sm-4">
                  <label class="required" [for]="'renewal'">Renewal / Migration</label>
                  <select class="form-control" id="renewal" name="renewal" formControlName="renewal" autoLinkToLabel>
                    <option *ngFor="let r of dorRenewalOptions" [ngValue]="r.id">{{ r.value }}</option>
                  </select>
                </div>
                <div class="form-group col-sm-4">
                  <label class="required" for="previousDocument">Previous Document</label>
                  <input class="form-control" id="previousDocument" type="text" formControlName="previousDocument" name="previousDocument" maxlength="128">
                </div>
                <div class="form-group col-sm-4"></div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center mb-3">
        <div class="col-md-10 card-block">
          <div class="m-2">
            <h5>ITSM Locations</h5>
            <div class="row">
              <div class="form-group col-lg-6">
                <label class="bold required" [for]="'soldToAddressId'">Sold-To Location</label>
                <select class="form-control" id="soldToAddressId" [hidden]="soldToAddresses &amp;&amp; soldToAddresses.length &lt;= 1" name="soldToAddressId" formControlName="soldToAddressId" autoLinkToLabel (change)="syncContactAndAddressIds()">
                  <option *ngFor="let addr of soldToAddresses" [ngValue]="addr.id">{{ addr.menuName }}</option>
                </select>
                <div class="row" *ngIf="soldToAddressId &amp;&amp; soldToAddressesMap &amp;&amp; soldToAddressesMap[soldToAddressId]">
                  <div class="col-sm-12" [hidden]="!soldToAddressesMap[soldToAddressId].businessPartnerId"><span><b>BP ID -</b><i> {{ soldToAddressesMap[soldToAddressId].businessPartnerId }}</i></span></div>
                  <div class="col-sm-12" [hidden]="!soldToAddressesMap[soldToAddressId].itsmSiteName"><span><b>SITE -</b><i> {{ soldToAddressesMap[soldToAddressId].itsmSiteName }}</i></span></div>
                  <div class="col-sm-12" [hidden]="!soldToAddressesMap[soldToAddressId].itsmBuilding"><span><b>BUILDING -</b><i> {{ soldToAddressesMap[soldToAddressId].itsmBuilding }}</i></span></div>
                  <div class="col-sm-12"><span>{{ soldToAddressesMap[soldToAddressId].name1 }}</span></div>
                  <div class="col-sm-12" [hidden]="!soldToAddressesMap[soldToAddressId].name2"><span>{{ soldToAddressesMap[soldToAddressId].name2 }}</span></div>
                  <div class="col-sm-12"><span>{{ soldToAddressesMap[soldToAddressId].line1 }}</span></div>
                  <div class="col-sm-12" [hidden]="!soldToAddressesMap[soldToAddressId].line2"><span>{{ soldToAddressesMap[soldToAddressId].line2 }}</span></div>
                  <div class="col-sm-12"><span>
                      {{ soldToAddressesMap[soldToAddressId].city }}{{ soldToAddressesMap[soldToAddressId].region ? ',' : '' }}
                       {{ soldToAddressesMap[soldToAddressId].region | region }}
                       {{ soldToAddressesMap[soldToAddressId].postalCode }}</span></div>
                  <div class="col-sm-12"><span>{{ soldToAddressesMap[soldToAddressId].country | country }}</span></div>
                </div>
              </div>
              <div class="form-group col-lg-6">
                <label class="bold required" [for]="'billToAddressId'">Bill-To Location</label>
                <select class="form-control" id="billToAddressId" [hidden]="billToAddresses &amp;&amp; billToAddresses.length &lt;= 1" name="billToAddressId" formControlName="billToAddressId" autoLinkToLabel (change)="syncContactAndAddressIds()">
                  <option *ngFor="let addr of billToAddresses" [ngValue]="addr.id">{{ addr.menuName }}</option>
                </select>
                <div class="row" *ngIf="billToAddressId &amp;&amp; billToAddressesMap &amp;&amp; billToAddressesMap[billToAddressId]">
                  <div class="col-sm-12" [hidden]="!billToAddressesMap[billToAddressId].businessPartnerId"><span><b>BP ID -</b><i> {{ billToAddressesMap[billToAddressId].businessPartnerId }}</i></span></div>
                  <div class="col-sm-12" [hidden]="!billToAddressesMap[billToAddressId].itsmSiteName"><span><b>SITE -</b><i> {{ billToAddressesMap[billToAddressId].itsmSiteName }}</i></span></div>
                  <div class="col-sm-12" [hidden]="!billToAddressesMap[billToAddressId].itsmBuilding"><span><b>BUILDING -</b><i> {{ billToAddressesMap[billToAddressId].itsmBuilding }}</i></span></div>
                  <div class="col-sm-12"><span>{{ billToAddressesMap[billToAddressId].name1 }}</span></div>
                  <div class="col-sm-12" [hidden]="!billToAddressesMap[billToAddressId].name2"><span>{{ billToAddressesMap[billToAddressId].name2 }}</span></div>
                  <div class="col-sm-12"><span>{{ billToAddressesMap[billToAddressId].line1 }}</span></div>
                  <div class="col-sm-12" [hidden]="!billToAddressesMap[billToAddressId].line2"><span>{{ billToAddressesMap[billToAddressId].line2 }}</span></div>
                  <div class="col-sm-12"><span>
                      {{ billToAddressesMap[billToAddressId].city }}{{ billToAddressesMap[billToAddressId].region ? ',' : '' }}
                       {{ billToAddressesMap[billToAddressId].region | region }}
                       {{ billToAddressesMap[billToAddressId].postalCode }}</span></div>
                  <div class="col-sm-12"><span>{{ billToAddressesMap[billToAddressId].country | country }}</span></div>
                </div>
              </div>
              <div class="form-group col-lg-6">
                <label class="bold required" [for]="'payerAddressId'">Payer Location</label>
                <select class="form-control" id="payerAddressId" [hidden]="payerAddresses &amp;&amp; payerAddresses.length &lt;= 1" name="payerAddressId" formControlName="payerAddressId" autoLinkToLabel (change)="syncContactAndAddressIds()">
                  <option *ngFor="let addr of payerAddresses" [ngValue]="addr.id">{{ addr.menuName }}</option>
                </select>
                <div class="row" *ngIf="payerAddressId &amp;&amp; payerAddressesMap &amp;&amp; payerAddressesMap[payerAddressId]">
                  <div class="col-sm-12" [hidden]="!payerAddressesMap[payerAddressId].businessPartnerId"><span><b>BP ID -</b><i> {{ payerAddressesMap[payerAddressId].businessPartnerId }}</i></span></div>
                  <div class="col-sm-12" [hidden]="!payerAddressesMap[payerAddressId].itsmSiteName"><span><b>SITE -</b><i> {{ payerAddressesMap[payerAddressId].itsmSiteName }}</i></span></div>
                  <div class="col-sm-12" [hidden]="!payerAddressesMap[payerAddressId].itsmBuilding"><span><b>BUILDING -</b><i> {{ payerAddressesMap[payerAddressId].itsmBuilding }}</i></span></div>
                  <div class="col-sm-12"><span>{{ payerAddressesMap[payerAddressId].name1 }}</span></div>
                  <div class="col-sm-12" [hidden]="!payerAddressesMap[payerAddressId].name2"><span>{{ payerAddressesMap[payerAddressId].name2 }}</span></div>
                  <div class="col-sm-12"><span>{{ payerAddressesMap[payerAddressId].line1 }}</span></div>
                  <div class="col-sm-12" [hidden]="!payerAddressesMap[payerAddressId].line2"><span>{{ payerAddressesMap[payerAddressId].line2 }}</span></div>
                  <div class="col-sm-12"><span>
                      {{ payerAddressesMap[payerAddressId].city }}{{ payerAddressesMap[payerAddressId].region ? ',' : '' }}
                       {{ payerAddressesMap[payerAddressId].region | region }}
                       {{ payerAddressesMap[payerAddressId].postalCode }}</span></div>
                  <div class="col-sm-12"><span>{{ payerAddressesMap[payerAddressId].country | country }}</span></div>
                </div>
              </div>
              <div class="form-group col-lg-6">
                <label class="bold" [for]="'endUserAddressId'">End User Location</label>
                <select class="form-control" id="endUserAddressId" [hidden]="endUserAddresses &amp;&amp; endUserAddresses.length &lt;= 1" name="endUserAddressId" formControlName="endUserAddressId" autoLinkToLabel (change)="syncContactAndAddressIds()">
                  <option *ngFor="let addr of endUserAddresses" [ngValue]="addr.id">{{ addr.menuName }}</option>
                </select>
                <div class="row" *ngIf="endUserAddressId &amp;&amp; endUserAddressesMap &amp;&amp; endUserAddressesMap[endUserAddressId]">
                  <div class="col-sm-12" [hidden]="!endUserAddressesMap[endUserAddressId].businessPartnerId"><span><b>BP ID -</b><i> {{ endUserAddressesMap[endUserAddressId].businessPartnerId }}</i></span></div>
                  <div class="col-sm-12" [hidden]="!endUserAddressesMap[endUserAddressId].itsmSiteName"><span><b>SITE -</b><i> {{ endUserAddressesMap[endUserAddressId].itsmSiteName }}</i></span></div>
                  <div class="col-sm-12" [hidden]="!endUserAddressesMap[endUserAddressId].itsmBuilding"><span><b>BUILDING -</b><i> {{ endUserAddressesMap[endUserAddressId].itsmBuilding }}</i></span></div>
                  <div class="col-sm-12" [hidden]="!endUserAddressesMap[endUserAddressId].name2"><span>{{ endUserAddressesMap[endUserAddressId].name2 }}</span></div>
                  <div class="col-sm-12"><span>{{ endUserAddressesMap[endUserAddressId].line1 }}</span></div>
                  <div class="col-sm-12" [hidden]="!endUserAddressesMap[endUserAddressId].line2"><span>{{ endUserAddressesMap[endUserAddressId].line2 }}</span></div>
                  <div class="col-sm-12"><span>
                      {{ endUserAddressesMap[endUserAddressId].city }}{{ endUserAddressesMap[endUserAddressId].region ? ',' : '' }}
                       {{ endUserAddressesMap[endUserAddressId].region | region }}
                       {{ endUserAddressesMap[endUserAddressId].postalCode }}</span></div>
                  <div class="col-sm-12"><span>{{ endUserAddressesMap[endUserAddressId].country | country }}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center mb-3" *ngIf="isRegionIndia">
        <div class="col-md-10 card-block">
          <div class="m-2">
            <div class="row mb-3">
              <div class="col-12">
                <h5 class="float-left">Bill From Structure</h5>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <div>
                  <label class="required" [for]="'billFromStructure'">Bill-From</label>
                </div>
                <div>
                  <div class="form-check float-left pr-2">
                    <input class="form-check-input" id="centralized" type="radio" name="billFromStructure" formControlName="billFromStructure" autoLinkToLabel value="CENTRALIZED" (change)="changedBillFrom()">
                    <label class="form-check-label">Centralized</label>
                  </div>
                  <div class="form-check float-left pr-2">
                    <input class="form-check-input" id="decentralized" type="radio" name="billFromStructure" formControlName="billFromStructure" autoLinkToLabel value="DECENTRALIZED" (change)="changedBillFrom()">
                    <label class="form-check-label">Decentralized</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12" *ngIf="isCentralizedStructured &amp;&amp; !loadingBillFromList" style="overflow-y: scroll; max-height:300px;">
                <table class="table table-responsive customer-table">
                  <thead>
                    <tr class="table-header-with-controls">
                      <th class="actions">Selection</th>
                      <th>Bill-From</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="billFromAccountsList">
                      <ng-container *ngFor="let account of billFromAccountsList; let idx = index;">
                        <tr [ngStyle]="{'font-weight': account.id === selectedBillFromAccount?.id ? 'bold' : 'normal'}">
                          <td class="form-group">
                            <div class="form-check tmc-radio">
                              <input id="selectedBillFrom" type="radio" name="selectedBillFrom" formControlName="selectedBillFrom" ngbTooltip="Select Bill-From account" container="body" (change)="setBillFromAccount(account)" [checked]="account.id === selectedBillFromAccount?.id">
                            </div>
                          </td>
                          <td><span ngbTooltip="BPID: {{account.value.billFromAccBPID}}" placement="left" container="body">{{account.value.billFromAccName}}</span></td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    <tr *ngIf="isCentralizedStructured &amp;&amp; !billFromAccountsList &amp;&amp; !loadingBillFromList">
                      <td></td>
                      <td>
                        <p class="text-center empty-table-message">There are no Bill-From accounts to display.</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row" *ngIf="isCentralizedStructured &amp;&amp; loadingBillFromList">
              <div class="col-12">
                <p class="text-center empty-table-message">Searching...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center mb-3">
        <div class="col-md-10 card-block">
          <div class="m-2">
            <div class="row mb-3">
              <div class="col-12">
                <h5 class="float-left">Contract Contacts</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12" style="overflow-x: auto;">
                <table class="table table-responsive customer-table">
                  <thead>
                    <tr class="table-header-with-controls">
                      <th class="actions">Type</th>
                      <th style="width: 300px;">Select Email Address</th>
                      <th style="width: 180px;">Name</th>
                      <th style="width: 160px;">BP ID</th>
                      <th style="width: 70px;">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="required-add-asterisk">{{ contactHumanReadableNames.contractAdmin }}</td>
                      <td>
                        <select class="form-control" id="hpContractAdminContactId" name="hpContractAdminContactId" formControlName="hpContractAdminContactId" autoLinkToLabel (change)="syncContactAndAddressIds()">
                          <option *ngFor="let ct of contactTypes.contractAdmin" [ngValue]="ct.id">{{ ct.emailAddress }}</option>
                        </select><span class="d-block" *ngIf="hpContractAdminContactId &amp;&amp; (!itsmContactsWithBpIdMap[hpContractAdminContactId] || !itsmContactsWithBpIdMap[hpContractAdminContactId].itsmContactId)" style="color: red;">INVALID contact</span>
                      </td>
                      <td>{{ hpContractAdminContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[hpContractAdminContactId] && itsmContactsWithBpIdMap[hpContractAdminContactId].name }}</td>
                      <td>{{ hpContractAdminContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[hpContractAdminContactId] && itsmContactsWithBpIdMap[hpContractAdminContactId].businessPartnerId }}</td>
                      <td class="text-center"><a class="nav-link p-0" *ngIf="!isMAActive" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Select Contact" (click)="selectContact(hpContractAdminContactId, settableContacts.contractAdmin)">search</a></td>
                    </tr>
                    <tr>
                      <td class="required-add-asterisk">{{ contactHumanReadableNames.accDelMgr }}</td>
                      <td>
                        <select class="form-control" id="hpAccDeliveryMgrContactId" name="hpAccDeliveryMgrContactId" formControlName="hpAccDeliveryMgrContactId" autoLinkToLabel (change)="syncContactAndAddressIds()">
                          <option *ngFor="let ct of contactTypes.accDelMgr" [ngValue]="ct.id">{{ ct.emailAddress }}</option>
                        </select><span class="d-block" *ngIf="hpAccDeliveryMgrContactId &amp;&amp; (!itsmContactsWithBpIdMap[hpAccDeliveryMgrContactId] || !itsmContactsWithBpIdMap[hpAccDeliveryMgrContactId].itsmContactId)" style="color: red;">INVALID contact</span>
                      </td>
                      <td>{{ hpAccDeliveryMgrContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[hpAccDeliveryMgrContactId] && itsmContactsWithBpIdMap[hpAccDeliveryMgrContactId].name }}</td>
                      <td>{{ hpAccDeliveryMgrContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[hpAccDeliveryMgrContactId] && itsmContactsWithBpIdMap[hpAccDeliveryMgrContactId].businessPartnerId }}</td>
                      <td class="text-center"><a class="nav-link p-0" *ngIf="!isMAActive" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Select Contact" (click)="selectContact(hpAccDeliveryMgrContactId, settableContacts.accDelMgr)">search</a></td>
                    </tr>
                    <tr>
                      <td class="required-add-asterisk">{{ contactHumanReadableNames.billTo }}</td>
                      <td>
                        <select class="form-control" id="billToContactId" name="billToContactId" formControlName="billToContactId" autoLinkToLabel (change)="syncContactAndAddressIds()">
                          <option *ngFor="let ct of contactTypes.billTo" [ngValue]="ct.id">{{ ct.emailAddress }}</option>
                        </select><span class="d-block" *ngIf="billToContactId &amp;&amp; (!itsmContactsWithBpIdMap[billToContactId] || !itsmContactsWithBpIdMap[billToContactId].itsmContactId)" style="color: red;">INVALID contact</span>
                      </td>
                      <td>{{ billToContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[billToContactId] && itsmContactsWithBpIdMap[billToContactId].name }}</td>
                      <td>{{ billToContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[billToContactId] && itsmContactsWithBpIdMap[billToContactId].businessPartnerId }}</td>
                      <td class="text-center"><a class="nav-link p-0" *ngIf="!isMAActive" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Select Contact" (click)="selectContact(billToContactId, settableContacts.billTo)">search</a></td>
                    </tr>
                    <tr>
                      <td class="required-add-asterisk">{{ contactHumanReadableNames.invoice }}</td>
                      <td>
                        <select class="form-control" id="invoiceContactId" name="invoiceContactId" formControlName="invoiceContactId" autoLinkToLabel (change)="syncContactAndAddressIds()">
                          <option *ngFor="let ct of contactTypes.invoice" [ngValue]="ct.id">{{ ct.emailAddress }}</option>
                        </select><span class="d-block" *ngIf="invoiceContactId &amp;&amp; (!itsmContactsWithBpIdMap[invoiceContactId] || !itsmContactsWithBpIdMap[invoiceContactId].itsmContactId)" style="color: red;">INVALID contact</span>
                      </td>
                      <td>{{ invoiceContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[invoiceContactId] && itsmContactsWithBpIdMap[invoiceContactId].name }}</td>
                      <td>{{ invoiceContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[invoiceContactId] && itsmContactsWithBpIdMap[invoiceContactId].businessPartnerId }}</td>
                      <td class="text-center"><a class="nav-link p-0" *ngIf="!isMAActive" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Select Contact" (click)="selectContact(invoiceContactId, settableContacts.invoice)">search</a></td>
                    </tr>
                    <tr>
                      <td class="required-add-asterisk">{{ contactHumanReadableNames.hpInvoice }}</td>
                      <td>
                        <select class="form-control" id="hpInvoiceContactId" name="hpInvoiceContactId" formControlName="hpInvoiceContactId" autoLinkToLabel (change)="syncContactAndAddressIds()">
                          <option *ngFor="let ct of contactTypes.hpInvoice" [ngValue]="ct.id">{{ ct.emailAddress }}</option>
                        </select><span class="d-block" *ngIf="hpInvoiceContactId &amp;&amp; (!itsmContactsWithBpIdMap[hpInvoiceContactId]||!itsmContactsWithBpIdMap[hpInvoiceContactId].itsmContactId)" style="color: red;">INVALID contact</span>
                      </td>
                      <td>{{ hpInvoiceContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[hpInvoiceContactId] && itsmContactsWithBpIdMap[hpInvoiceContactId].name }}</td>
                      <td>{{ hpInvoiceContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[hpInvoiceContactId] && itsmContactsWithBpIdMap[hpInvoiceContactId].businessPartnerId }}</td>
                      <td class="text-center"><a class="nav-link p-0" *ngIf="!isMAActive" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Select Contact" (click)="selectContact(hpInvoiceContactId, settableContacts.hpInvoice)">search</a></td>
                    </tr>
                    <tr>
                      <td class="required-add-asterisk">{{ contactHumanReadableNames.sales }}</td>
                      <td>
                        <select class="form-control" id="hpSalesRepContactId" name="hpSalesRepContactId" formControlName="hpSalesRepContactId" autoLinkToLabel (change)="syncContactAndAddressIds()">
                          <option *ngFor="let ct of contactTypes.sales" [ngValue]="ct.id">{{ ct.emailAddress }}</option>
                        </select><span class="d-block" *ngIf="hpSalesRepContactId &amp;&amp; (!itsmContactsWithBpIdMap[hpSalesRepContactId] || !itsmContactsWithBpIdMap[hpSalesRepContactId].itsmContactId)" style="color: red;">INVALID contact</span>
                      </td>
                      <td>{{ hpSalesRepContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[hpSalesRepContactId] && itsmContactsWithBpIdMap[hpSalesRepContactId].name }}</td>
                      <td>{{ hpSalesRepContactId && itsmContactsWithBpIdMap && itsmContactsWithBpIdMap[hpSalesRepContactId] && itsmContactsWithBpIdMap[hpSalesRepContactId].businessPartnerId }}</td>
                      <td class="text-center"><a class="nav-link p-0" *ngIf="!isMAActive" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Select Contact" (click)="selectContact(hpSalesRepContactId, settableContacts.sales)">search</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
</div>